import React from 'react';
import { RBField, RBChipInput } from '../theme';

const SKILL_SUGGESTIONS = [
  'MS Excel', 'Tally', 'Data Entry', 'Customer Service', 'Sales', 'Marketing',
  'Team Management', 'Communication', 'Driving', 'Cooking', 'Housekeeping',
  'Computer Basics', 'English Speaking', 'Accounting', 'Field Work',
  'Social Media', 'Photoshop', 'Typing', 'Billing', 'Store Management',
];

export default function SkillsStep({ state, setState }) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-400">
        Type a skill and press Enter to add it. Add at least 3–5 skills that match the jobs you want.
      </p>
      <RBField label="Your skills">
        <RBChipInput
          values={state.skills}
          onChange={(skills) => setState((s) => ({ ...s, skills }))}
          suggestions={SKILL_SUGGESTIONS}
          placeholder="e.g. MS Excel, Customer Service…"
        />
      </RBField>
    </div>
  );
}
